import { render, staticRenderFns } from "./PendingTeamTable.vue?vue&type=template&id=4de5e406&"
import script from "./PendingTeamTable.vue?vue&type=script&lang=js&"
export * from "./PendingTeamTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports